import fetchValuation from '../Services/fetchValuation';
import checkIfProjectShouldComplete from '../Services/checkIfProjectShouldComplete';

export default () => async (dispatch) => {
  
  dispatch(fetchValuation());

  dispatch(checkIfProjectShouldComplete());
  
}